import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  appBar: {
    borderRadius: 15,
    margin: '30px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#44355B'
  },
  heading: {
    color: 'rgba(255,255,255, 1)',
    textShadow: '2px 2px 5px gray'

  },
  image: {
    marginLeft: '15px',
    // width: '7%',
    // height: '7%',
    // boxShadow: '2.5px 2.5px 2.5px 1px #ccc'
  },
  [theme.breakpoints.down('sm')]:{
    mainContainer: {
      flexDirection: "column-reverse"
    }
  }
}))